<template>
    <div class="a7-sessao-usuario">
      <gw-icon-button class="icon-nav-bar" icon="fa-user" @click="openDropDown"
      :id="`gw-icon-button-${uuid}`">
        {{this.apelido}}
      </gw-icon-button>
      <gw-pop-up class="dropdown-menu" :visible.sync="dialogVisible"
        :reference-element-id="`gw-icon-button-${uuid}`">
        <ul>
          <li>{{this.apelido}}</li>
          <li class="dropdown-divider"></li>
        </ul>
        <div class="logout">
          <gw-button  @click="logOut">
            <gw-icon class="fa fa-power-off"/>
            {{this.$t("PainelMedicaoIndicador.ui.botaoSair")}}
          </gw-button>
        </div>
      </gw-pop-up>
    </div>
</template>

<script>
import {
    GwIconButton,
    GwPopUp,
    GwButton,
    GwIcon
} from 'guaxinim-web';
import SessaoRestResource from '@/components/sessao/SessaoRestResource';
import TokenStorage from '@/js/TokenStorage';

export default {
  name: "a7-sessao-usuario",
  components: {
    GwIconButton,
    GwPopUp,
    GwButton,
    GwIcon
  },
  watch: {
    dataSessao(newValue){
      this.apelido = newValue.apelido;
    }
  },
  data() {
    return {
      sessaoRestResource: SessaoRestResource,
      dialogVisible: false,
      dataSessao: null,
      apelido: null
    }
  },
  created() {
    this.sessaoRestResource.getSessao()
      .then(data => this.dataSessao = data.usuario)
      .catch((err) => this.$gw.defaultExceptionHandler.handleUnknowException(err, this));
  },
  methods: {
    openDropDown() {
      this.dialogVisible = true
    },
    logOut() {
      TokenStorage.removeAuthToken();
      location.reload();
    }
  }
}
</script>

<style lang="scss" scoped>
  .a7-sessao-usuario {

    .dropdown-menu {
      font-size: 15px;
      color: #72767b;
    }

    .dropdown-menu ul {
      list-style-type:none;
      padding: 0;
      width: 200px;
      padding-top: 5px;
    }

    .dropdown-menu ul li {
      width: 100% ;
      text-align: center;
      font-weight: 600;
    }

    .dropdown-divider {
      height: 0;
      border-top: 1px solid #dfe1e2;
    }

    .logout {
      text-align: right;
      padding: 5px;
    }
  }
</style>
